<template>
  <div>
    <CCard class="bg-style3">
      <CCardBody>



      <!-- <CCardBody class="pb-0"> -->
        <CRow>
          <CCol>
            <CDataTable
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              :fields="fields"
              :items="getFilteredCars()"
              :items-per-page="small ? 50 : 5"
              :dark="dark"
              pagination
            >
              <template #index="{item,index}"><td>{{ index + 1 }}</td></template>
              <template #title="{item}"><td>{{ getLabelFromTitleArray(item.title) }}</td></template>
              <template #type="{item}"><td>{{ getLabelFromTitleArray(item.type) }}</td></template>
              <template #description="{item}"><td>{{ getLabelFromTitleArray(item.description) }}</td></template>
              <template #status="{item}"><td>{{ item.status }}</td></template>
              <template #action="{item}">
                <td class="text-center">
                  <CButton size="sm" color="info" shape="pill" variant="outline" class="mr-1" v-c-tooltip.hover.click="'แก้ไข'" @click="editCar(item)" :disabled="!canEditCars">
                    <CIcon name="cil-pencil"/>
                  </CButton>
                  <CButton size="sm" color="warning" shape="pill" variant="outline" class="mr-1" v-c-tooltip.hover.click="'ซูม'"  @click="zoomcar(item)" :disabled="!canEditCars">
                    <CIcon name="cil-zoom-in"/>
                  </CButton>
                  <CButton size="sm" color="danger" shape="pill" variant="outline" v-c-tooltip.hover.click="'ลบ'" @click="deleteCar(item)" :disabled="!canEditCars">
                    <CIcon name="cil-trash"/>
                  </CButton>
                </td>
              </template>

              
            </CDataTable>
                <div class="d-flex justify-content-end align-items-center mr-2">
                  <CButton v-c-tooltip.hover.click="'เพิ่ม'" size="sm" shape="pill" variant="outline" color="info" @click="openCreateModal" :disabled="!canEditCars">
                    <CIcon name="cil-plus" class="me-2"/> 
                  </CButton>
                </div>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <!-- Modal สร้าง/แก้ไขรถ -->
    <CModal
      :title="isCreating ? 'เพิ่มรถ' : 'แก้ไขข้อมูลรถ'"
      :show.sync="showEditModal"
      size="lg"
      :centered="true"
      class="modal-rounded"
    >
      <template #body-wrapper>
        <div style="padding: 1rem;">
          <div class="form-group">
            <label>ยี่ห้อ/รุ่น (TH)</label>
            <input type="text" v-model="carForm.titleTH" class="form-control" />
          </div>
          <div class="form-group">
            <label>ยี่ห้อ/รุ่น (EN)</label>
            <input type="text" v-model="carForm.titleEN" class="form-control" />
          </div>
          <div class="form-group">
            <label>ป้ายทะเบียน</label>
            <input type="text" v-model="carForm.plate" class="form-control" />
          </div>
          <div class="form-group">
            <label>ประเภทรถ</label>
            <select v-model="carForm.typeKey" class="form-control">
              <option value="transport">รถรับส่ง</option>
              <option value="ambulance">รถพยาบาล</option>
            </select>
          </div>
          <div class="form-group">
            <label>สถานะ</label>
            <select v-model="carForm.status" class="form-control">
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
          <div class="form-group">
            <label>สถานะคำร้องขอ</label>
            <select v-model="carForm.request_status" class="form-control">
              <option value="pending">Pending</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
            </select>
          </div>
          <div class="form-group">
            <label>พิกัด (ละติจูด, ลองจิจูด)</label>
            <div class="row no-gutters">
              <div class="col-6 pr-1"><input type="number" v-model.number="carForm.coordinates[0]" placeholder="Latitude" class="form-control"/></div>
              <div class="col-6 pl-1"><input type="number" v-model.number="carForm.coordinates[1]" placeholder="Longitude" class="form-control"/></div>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <CButton class="mr-2" size="sm" color="danger" shape="pill" variant="outline" @click="closeModal">
          <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-ban" size="sm"/> CANCEL </span>
        </CButton>
        <CButton size="sm" color="success" shape="pill" variant="outline" @click="isCreating ? createCar() : saveCar()">
          <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-save" size="sm"/> SUBMIT </span>
        </CButton>
      </template>
    </CModal>
  </div>
  
</template>

<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "CarTable",
  props: {
    icon: { type: String, default: "cil-car" },
    caption: { type: String, default: "รายการรถ" },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    fields: {
      type: Array,
      default: () => [
        { key: "index", label: "#", _style: "width:20px;text-align:center" },
        { key: "title", label: "ยี่ห้อ/รุ่น" },
        { key: "type", label: "ประเภท" },
        { key: "description", label: "ป้ายทะเบียน" },
        { key: "status", label: "สถานะ" },
        { key: "action", label: "จัดการ", _style: "width:140px;text-align:center" }
      ]
    }
  },
  data() {
    return {
      options: { status: [] },
      select: { status: { label: "-", value: "" } },
      objs: { status: "" },
      showEditModal: false,
      isCreating: false,
      carForm: {
        _id: null,
        titleTH: '',
        titleEN: '',
        plate: '',
        typeKey: 'transport',
        status: 'active',
        request_status: 'pending',
        coordinates: [0, 0]
      }
    };
  },
  computed: {
    ...mapGetters({
      lang: "setting/lang",
      cars: "Car/cars",
      selectedUser: "Auth/selectedUser"
    }),

    allRoles() {
      return this.selectedUser?.authen?.flatMap(a => a.roles) || [];
    },
    canEditCars() {
      return this.allRoles.includes("2")|| this.allRoles.includes("3");
    },
  },
  watch: {
    lang() { this.buildOptions(); },
    cars() { this.buildOptions(); },
    "select.status"(value) {
      this.objs.status = value.value;
      this.$emit("select", this.objs);
    }
  },
  created() {
    this.loadCars();
  },
  methods: {
    loadCars() {
      this.$store.dispatch("Car/cars");
    },
    buildOptions() {
      const lang = this.lang || "th";
      this.options.status = [{ label: "-", value: "" }];
      (this.cars || []).forEach(car => {
        if (!this.options.status.find(o => o.value === car.status)) {
          this.options.status.push({ label: car.status, value: car.status });
        }
      });
      if (!this.select.status.value) this.select.status = this.options.status[0];
    },
    getFilteredCars() {
      const statusFilter = this.select.status.value;
      return (this.cars || []).filter(car => !statusFilter || car.status === statusFilter);
    },
    getLabelFromTitleArray(arr) {
      if (!Array.isArray(arr)) return "-";
      const lang = this.lang || "th";
      const found = arr.find(t => t.key === lang);
      return (found && found.value) || (arr[0] && arr[0].value) || "-";
    },

    // ---------- Modal สำหรับสร้าง/แก้ไข ----------
    openCreateModal() {
      if (!this.canEditCars) return;
      this.isCreating = true;
      this.carForm = {
        _id: null,
        titleTH: '',
        titleEN: '',
        plate: '',
        status: 'active',
        request_status: 'pending',
        coordinates: [99.8941, 20.046]
      };
      this.showEditModal = true;
    },
    editCar(car) {
      if (!this.canEditCars) return;
      this.isCreating = false;
      this.carForm = {
        _id: car._id,
        titleTH: car.title.find(t => t.key === "th")?.value || "",
        titleEN: car.title.find(t => t.key === "en")?.value || "",
        plate: car.description.find(d => d.key === "plate")?.value || "",
        status: car.status || "active",
        request_status: car.request_status || "pending",
        coordinates: car.coordinates ? [...car.coordinates] : [0, 0]
      };
      // populate typeKey from car.type if available
      try {
        const typeArr = car.type || [];
        const th = (typeArr.find(t => t.key === 'th') || {}).value || '';
        if (th.includes('พยาบาล')) this.carForm.typeKey = 'ambulance';
        else this.carForm.typeKey = 'transport';
      } catch (e) {
        this.carForm.typeKey = 'transport';
      }
      this.showEditModal = true;
    },
    closeModal() {
      this.showEditModal = false;
      this.carForm = {
        _id: null,
        titleTH: '',
        titleEN: '',
        plate: '',
        status: 'active',
        request_status: 'pending',
        coordinates: [0, 0]
      };
      this.isCreating = false;
    },

    // ---------- สร้างรถใหม่ ----------
    async createCar() {
      if (!this.canEditCars) return;
      const payload = {
        title: [
          { key: 'th', value: this.carForm.titleTH },
          { key: 'en', value: this.carForm.titleEN }
        ],
        description: [
          { key: 'plate', value: this.carForm.plate }
        ],
        type: this.buildTypeArray(this.carForm.typeKey),
        status: this.carForm.status,
        request_status: this.carForm.request_status,
        coordinates: this.carForm.coordinates
      };
      try {
        await this.$store.dispatch('Car/createCar', payload);
        this.closeModal();
        Swal.fire({ icon: 'success', title: 'สร้างเรียบร้อย', text: 'รถใหม่ถูกสร้างเรียบร้อยแล้ว', timer: 2000, showConfirmButton: false });
      } catch (err) {
        Swal.fire({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: err.message || err });
      }
    },

    // ---------- บันทึกการแก้ไข ----------
    async saveCar() {
      if (!this.canEditCars) return;
      const payload = {
        _id: this.carForm._id,
        title: [
          { key: 'th', value: this.carForm.titleTH },
          { key: 'en', value: this.carForm.titleEN }
        ],
        description: [
          { key: 'plate', value: this.carForm.plate }
        ],
        type: this.buildTypeArray(this.carForm.typeKey),
        status: this.carForm.status,
        request_status: this.carForm.request_status,
        coordinates: this.carForm.coordinates
      };
      try {
        await this.$store.dispatch("Car/updateCar", payload);
        this.closeModal();
        Swal.fire({ icon: 'success', title: 'บันทึกเรียบร้อย', text: 'ข้อมูลรถถูกแก้ไขเรียบร้อยแล้ว', timer: 2000, showConfirmButton: false });
      } catch (err) {
        Swal.fire({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: err.message || err });
      }
    },

    // ---------- ลบรถ ----------
    async deleteCar(car) {
      if (!this.canEditCars) return;
      const result = await Swal.fire({
        icon: 'warning',
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบรถคันนี้หรือไม่?',
        showCancelButton: true,
        confirmButtonText: 'ลบ',
        cancelButtonText: 'ยกเลิก'
      });
      if (result.isConfirmed) {
        try {
          await this.$store.dispatch("Car/deleteCar", car._id);
          Swal.fire({ icon: 'success', title: 'ลบเรียบร้อย', timer: 1500, showConfirmButton: false });
        } catch (err) {
          Swal.fire({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: err.message || err });
        }
      }
    }
    ,
    // emit coordinates so parent can update map center
    zoomcar(car) {
      try {
        const loc = (car && (car.coordinates || car.location)) || null;
        const latLng = this.getLatLngFromLocation(loc);
        if (latLng && Number.isFinite(latLng.lat) && Number.isFinite(latLng.lng)) {
          // ดึง title จาก car.title array
          const title = this.getLabelFromTitleArray(car.title || []);
          // ดึง plate จาก car.description array
          const plate = car.description?.find(d => d.key === 'plate')?.value || '-';
          
          this.$emit('zoom-to', { 
            lat: latLng.lat, 
            lng: latLng.lng, 
            zoom: 16,
            title: title,
            plate: plate,
            label: `${title} (${plate})`
          });
        } else {
          Swal.fire({ icon: 'info', title: 'ไม่มีพิกัด', text: 'รถคันนี้ยังไม่มีพิกัด' });
        }
      } catch (err) {
        console.error('zoomcar error', err);
      }
    },
    getLatLngFromLocation(loc) {
      if (!loc) return null;
      if (loc && Array.isArray(loc.coordinates) && loc.coordinates.length >= 2) {
        const [lng, lat] = loc.coordinates;
        if (typeof lat === 'number' && typeof lng === 'number') {
          return { lat, lng };
        }
      }
      const latObj = loc.lat ?? loc.latitude;
      const lngObj = loc.lng ?? loc.longitude;
      if (typeof latObj === 'number' && typeof lngObj === 'number') {
        return { lat: latObj, lng: lngObj };
      }
      if (Array.isArray(loc) && loc.length >= 2) {
        const a = Number(loc[0]);
        const b = Number(loc[1]);
        if (Number.isFinite(a) && Number.isFinite(b)) {
          if (Math.abs(a) <= 90 && Math.abs(b) <= 180) {
            return { lat: a, lng: b };
          } else {
            return { lat: b, lng: a };
          }
        }
      }
      return null;
    },
    buildTypeArray(key) {
      if (key === 'ambulance') {
        return [
          { key: 'th', value: 'รถพยาบาล' },
          { key: 'en', value: 'Ambulance' }
        ];
      }
      // default to transport
      return [
        { key: 'th', value: 'รถรับส่ง' },
        { key: 'en', value: 'Transport' }
      ];
    },
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}
.form-group label {
  font-weight: 600;
  margin-bottom: 0.25rem;
  display: block;
}
.form-control {
  width: 100%;
  padding: 0.5rem;
  border-radius: 0.25rem;
  border: 1px solid #e9ecef;
}

::v-deep .pagination {
  justify-content: flex-start !important;
  margin-left: 20px;
}

::v-deep .modal-rounded .modal-content {
  border-radius: 1rem !important;
}
</style>
